// Vuex requires Promise. If your supporting browsers do not implement Promise (e.g. IE), you can use a polyfill library, such as es6-promise.
// import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
import EasyAccess from 'vuex-easy-access'

import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import modules from './modules'

Vue.config.devtools = window.APPDATA.debug;
Vue.use(Vuex);

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules,
    plugins: [EasyAccess()],
})